import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { CHEVRON_LEFT, PHOTO } from "../../assets";

function PhotoDetails() {
  return (
    <LandingPageLayout
      title={<>Picture Gallery</>}
      currentLink={"Picture Gallery"}
    >
      <div className="flex flex-col gap-5 sm:gap-7 w-full py-8 sm:py-10 px-4 sm:px-8 lg:px-20 bg-[#F7F7F7]">
        <span className="text-xl sm:text-2xl font-bold text-primary-300">
          Swearing In of Chairmen & Members
        </span>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-10">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => (
            <div
              key={index}
              className="w-full h-fit bg-white gap-y-2 sm:gap-y-3 flex flex-col items-center rounded-md p-2 sm:p-3"
            >
              <img
                src={PHOTO}
                className="w-full h-[150px] sm:h-[180px] lg:h-[207px] object-cover rounded-md"
                alt={`Gallery image ${index + 1}`}
              />
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center space-x-3 sm:space-x-5 bg-white p-4">
          <button
            type="button"
            onClick={() => {}}
            className={`border border-[#EBEBEB] rounded-xl w-[35px] sm:w-[40px] h-[35px] sm:h-[40px] lg:flex hidden items-center gap-x-2 justify-center`}
          >
            <img
              src={CHEVRON_LEFT}
              className="w-[16px] sm:w-[20px] h-[16px] sm:h-[20px]"
              alt="Previous"
            />
          </button>
          <div
            className={`flex items-center gap-x-1 sm:gap-x-2 ${
              [1, 2, 3, 4, 5, 6].length > 5 &&
              "max-w-[180px] sm:max-w-[200px] overflow-x-auto"
            }`}
          >
            {[1, 2, 4, 5, 6, 7].map((page: any, index: number) => (
              <button
                key={index}
                className={`flex items-center justify-center pt-[0.5px] hover:bg-globalGreen hover:text-white transition-all duration-300 gap-x-2 min-w-[35px] sm:min-w-[40px] h-[35px] sm:h-[40px] rounded-xl ${
                  page.active
                    ? "bg-globalGreen text-white"
                    : "border text-[#2A2E34]"
                } `}
              >
                <span className={`text-[11px] sm:text-[13px]`}>{page}</span>
              </button>
            ))}
          </div>
          <button
            type="button"
            className={`border border-[#EBEBEB] rounded-xl gap-x-2 w-[35px] sm:w-[40px] h-[35px] sm:h-[40px] lg:flex hidden items-center justify-center`}
          >
            <img
              src={CHEVRON_LEFT}
              className="w-[16px] sm:w-[20px] h-[16px] sm:h-[20px] scale-x-[-1]"
              alt="Next"
            />
          </button>
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default PhotoDetails;
